/**
 * Created by elad on 15 נובמבר 2016.
 */
import VueRouter from "vue-router";
import middleware from "src/middleware";
import UsersView from "src/view/users/UsersView";
import CompaniesView from "src/view/companies/CompaniesView";
import GamesView from "src/view/games/GamesView";
import HotGamesView from "src/view/hotGames/HotGamesView";
import GameLogsView from "src/view/gamelogs/GameLogsView";
import Dashboard from "./Dashboard";
import QuestionView from "root/packages/closeapp/QuestionsManager/assets/views/questions/QuestionsView";
import GameQuestionView from "dev/view/gameQuestions/GameQuestionView";
import PlayView from "dev/view/play/PlayView";
import TypesView from "dev/view/types/TypesView";
import Home from "dev/view/home/Home";
import UpdatesView from "dev/view/updates/UpdatesView";
import OrganizationsView from "dev/view/organizations/OrganizationsView";
import PublicUserForm from "dev/view/users/PublicUserForm";
import CreateGame from "./view/games/CreateGame";


const routes = [
	{path: "/", redirect: {name: "home-page"}, name: "login-page"},
	{path: "/game/:id", component: PlayView, name: "play-page"},
	{path: "/game/share/:id", component: PlayView, name: "play-page"},
	{
		path: "/dashboard",
		component: Dashboard,
		children: [
			{path: "/register", component: PublicUserForm, name: "register"},
			{path: "/home", component: Home, name: "home-page", meta: {"CheckMiddleware": true}},
			{
				path: "/type", component: TypesView, name: "game-type-page", meta: {"RequireAuth": true}
			},
			{
				path: "/organizations",
				component: OrganizationsView,
				name: "organization-page",
				meta: {"RequireAuth": true}
			},
			{path: "/users", component: UsersView, name: "users-page", meta: {"RequireAuth": true}},
			{path: "/companies", component: CompaniesView, name: "companies-page", meta: {"RequireAuth": true}},
			{path: "questions", component: QuestionView, name: "questions-page", meta: {"RequireAuth": true}},
			{path: "/games", component: GamesView, name: "games-page", meta: {"RequireAuth": true}},
			{path: "/games/form/:id?", component: CreateGame, name: "game-form", meta: {"RequireAuth": true}},
			{path: "/hot-games", component: HotGamesView, name: "hot-games-page", meta: {"RequireAuth": true}},
			{path: "/game/edit/:id", component: GameQuestionView, name: "game-question", meta: {"RequireAuth": true}},
			{path: "/game-logs", component: GameLogsView, name: "game-log-page", meta: {"RequireAuth": true}},
			{path: "/updates", component: UpdatesView, name: "updates-page", meta: {"RequireAuth": true}}
		]
	}
];

const router = new VueRouter({
	history: false,
	mode: "history",
	routes
});

router.beforeEach((to, from, next) => {
	middleware.check(to, from, next);
});

export default router;
